/* custom-cl-ontop — the scroll progress Heights' "Why … comes out on top" runs on its list:
   the rail fills down to the deepest item you have reached, reached items sit navy, the ones
   below stay muted. Measured yourheights.com 2026-08-27.

   The photo stack cross-fades with the list. Measured on Heights 2026-08-27: four images stacked
   absolutely in a sticky overflow-hidden box, opacity transitioned 300ms ease-in-out, turned on
   CUMULATIVELY (1|0|0|0 → 1|1|1|0 → 1|1|1|1) so scrolling up fades the top frame back out and
   reveals the one beneath. An earlier pass of mine read opacity off the <img> instead of its
   wrapper, concluded Heights had one static photo, and deleted this. It does not.

   Setting data-js is what arms the muted state, so with no JS the list degrades to all-navy
   and fully readable. rAF-throttled, not IntersectionObserver (IO fires on threshold crossings,
   not on continuous position — wrong tool for a progress rail). */
(function () {
  function init(root) {
    if (!root || root.__clOt) return;
    root.__clOt = true;

    var items = [].slice.call(root.querySelectorAll('[data-cl-ot-item]'));
    var photos = [].slice.call(root.querySelectorAll('[data-cl-ot-ph]'));
    var fill = root.querySelector('.cl-ot__fill');
    var list = root.querySelector('.cl-ot__items');
    if (!items.length) return;

    root.setAttribute('data-js', '');

    var current = -2;                       // -1 is a real state, so seed outside the range
    function paint() {
      /* Deepest item whose top has passed the read line. -1 = the section is still below the
         reader, so nothing is lit yet — without this the first item was permanently active
         even while the section sat off-screen, which read as broken on the way down. */
      var line = window.innerHeight * 0.42;
      var deepest = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getBoundingClientRect().top <= line) deepest = i;
      }

      if (deepest !== current) {
        current = deepest;
        for (var j = 0; j < items.length; j++) {
          items[j].classList.toggle('is-active', j <= deepest);
        }
        /* Cumulative, exactly as Heights does it: every frame up to the deepest reached stays
           opaque and later ones paint over earlier ones, so the visible image is the deepest.
           Frame 0 never fades out — there is always something behind the stack. */
        var lit = deepest < 0 ? 0 : deepest;
        for (var k = 0; k < photos.length; k++) {
          photos[k].classList.toggle('is-shown', k <= lit);
        }
      }

      if (fill && list) {
        var h = 0;
        if (deepest >= 0) {
          var dot = items[deepest].querySelector('.cl-ot__dot');
          if (dot) {
            h = (dot.getBoundingClientRect().top + dot.offsetHeight / 2) - list.getBoundingClientRect().top;
          }
        }
        fill.style.height = Math.max(0, Math.round(h)) + 'px';
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  function boot() { document.querySelectorAll('[data-cl-ot]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
